import axios from "axios";
import {jwtDecode} from "jwt-decode";
import {appRoutes} from "../../../routes";
import {UserTypeEnum, userTypes} from "../../model/user/UserModel";
import {ResultModel} from "../../model/base/ResultModel";
import {sha256} from 'js-sha256';
import {ServiceCountryModel} from "../../model/serviceCountry/ServiceCountryModel";
import config from "../../../config/env/config";


const API_URL = config.baseApiUrl;


const login = async (mail: any | undefined, pass: any | undefined) => {
    const email = btoa(mail);

    const response = await axios.post(
        API_URL + "/loginAdmin", {
            email: email,
            password: pass
        }
    );
    return response.data.data;
};

const countryAdminLogin = async (mail: any | undefined, pass: any | undefined) => {
    const decodedMail = btoa(mail);
    const decodedPass = btoa(pass);

    const response = await axios.post(
        API_URL + "/country-admin-login", {
            email: decodedMail,
            password: decodedPass
        }
    );
    return response.data.data;
};

/**
 * Havalimanı Karşılamacı girişi.
 * Backend (AirportGreeterController#loginAirportGreeter) ham email/şifre bekler,
 * base64 kodlama YAPILMAZ. Başarıda data.token ve data.airportGreeter döner.
 */
const airportGreeterLogin = async (mail: string | undefined, pass: string | undefined) => {
    const response = await axios.post(
        API_URL + "/api/loginAirportGreeter", {
            email: mail,
            password: pass
        }
    );
    return response.data.data;
};

const loginAgentAdmin = async (mail: any | undefined, pass: any | undefined): Promise<ResultModel<any>> => {
    const email = btoa(mail);

    const response = await axios.post<ResultModel<any>>(
        API_URL + "/loginAgentAdmin", {
            email: email,
            password: pass
        }
    );

    return response.data;
}

const loginFirmAdmin = async (phone: string, loginSalt: string | undefined): Promise<ResultModel<any>> => {
    const encodedPhone = btoa(phone);

    const body = {
        phone: encodedPhone
    };

    const bodyString = JSON.stringify(body);
    const hash = sha256(bodyString + loginSalt);

    const response = await axios.post<ResultModel<any>>(
        API_URL + "/loginFirm",
        body,
        {
            headers: {
                "x-request-hash": hash
            }
        }
    );

    return response.data;
};

const loginPassenger = async (phone: string, loginSalt: string | undefined): Promise<ResultModel<any>> => {
    const encodedPhone = btoa(phone);

    const body = {
        phone: encodedPhone
    };

    const bodyString = JSON.stringify(body);
    const hash = sha256(bodyString + loginSalt);

    const response = await axios.post<ResultModel<any>>(
        API_URL + "/loginPassenger",
        body,
        {
            headers: {
                "x-request-hash": hash
            }
        }
    );

    return response.data;
};

const confirmSmsFirm = async (phone: string | undefined, password: string | undefined): Promise<ResultModel<any>> => {
    const response = await axios.post<ResultModel<any>>(
        API_URL + "/confirmSmsFirm", {
            phone: phone,
            password: password
        }
    );

    return response.data;
}

const confirmSmsPassenger = async (phone: string | undefined, password: string | undefined): Promise<ResultModel<any>> => {
    const response = await axios.post<ResultModel<any>>(
        API_URL + "/confirmSms", {
            phone: phone,
            password: password
        }
    );

    return response.data;
}

const getAgentApiKeyFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.apiKey || null;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getFirmServiceCountryIdFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.servicedCountriesId || null;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getAgentIdFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.agentId || null;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getAgentApiSecretFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.apiSecret || null;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getUsernameFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.name || null;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getUserAvatarFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.avatar || null;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getUserTypeFromToken = (): string | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.role as UserTypeEnum in UserTypeEnum ? userTypes[decodedJwt?.role as UserTypeEnum].name : '';
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const getCountryAdminCountriesFromToken = (): ServiceCountryModel[] => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return [];

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.servicedCountries;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return [];
    }
};

const getUserType = (): UserTypeEnum | undefined => {
    const userToken = localStorage.getItem("token");
    if (!userToken) return undefined;

    try {
        const decodedJwt = jwtDecode<any>(userToken);
        return decodedJwt?.role;
    } catch (error) {
        console.error("Token decoding failed:", error);
        return undefined;
    }
};

const isUserInRole = (role: string): boolean => {
    const userToken = localStorage.getItem("token");
    if (!userToken)
        return false;
    const decodedJwt = jwtDecode<any>(userToken);
    return decodedJwt.scopes.findIndex((s: any) => s === role) !== -1;
}
const isAuthenticated = (): boolean => {
    return !!localStorage.getItem("token");
}
const removeToken = () => {
    return new Promise<void>((resolve) => {
        localStorage.removeItem("token");
        resolve();
    });
};
const logout = async () => {
    try {
        await removeToken();
        window.location.href = appRoutes.main.search;

    } catch (error) {
        console.error(error);
    }

};

const getCurrentUserName = (): string => {
    const userToken = localStorage.getItem("token");
    if (!userToken)
        return "";
    const decodedJwt = jwtDecode<any>(userToken);
    return decodedJwt.name || "";
}
const authService = {
    login,
    logout,
    isAuthenticated,
    isUserInRole,
    getCurrentUserName,
    getUsernameFromToken,
    getUserTypeFromToken,
    getUserAvatarFromToken,
    loginAgentAdmin,
    getAgentApiKeyFromToken,
    getAgentApiSecretFromToken,
    getUserType,
    getAgentIdFromToken,
    loginFirmAdmin,
    confirmSmsFirm,
    getFirmServiceCountryIdFromToken,
    loginPassenger,
    confirmSmsPassenger,
    getCountryAdminCountriesFromToken,
    countryAdminLogin,
    airportGreeterLogin
};
export default authService;